/**
 * California fallback body-class sync.
 *
 * `snippets/ca-init.liquid` adds `body.ca-active` before paint based on the
 * stored region. This module keeps that class in sync for the rest of the
 * session: it re-applies on load and toggles whenever the visitor changes their
 * region via the header / mobile controls (the `theme:region:state-changed`
 * event dispatched from `src/js/header.js` and `src/js/mobile-menu.js`).
 *
 * `?ca_preview=1` forces `ca-active` on so the client can preview California
 * content in the theme editor, where the region is never set.
 */

const REGION_LS_KEY = 'wyld_us_state'
const CA_STATE = 'California'
const CA_BODY_CLASS = 'ca-active'

function isPreview() {
  try {
    return new URLSearchParams(window.location.search).get('ca_preview') === '1'
  } catch {
    return false
  }
}

function safeGet(key) {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

function applyCaClass(state) {
  const active = state === CA_STATE || isPreview()
  document.body.classList.toggle(CA_BODY_CLASS, active)
}

function initRegionCaToggle() {
  applyCaClass(safeGet(REGION_LS_KEY))

  document.addEventListener('theme:region:state-changed', (e) => {
    applyCaClass(e.detail?.state)
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRegionCaToggle)
} else {
  initRegionCaToggle()
}
